<template>
  <v-checkbox
      :error-messages="error"
      v-model="isChecked"
      :label="translation(translationList.ask_for_road_assistance, 'Doresc asistență rutieră pentru autovehiculul personal.')"
  ></v-checkbox>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'TravelCheckboxRoadAssistance',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-travel-status', {field: 'road_assistance_agreement', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-travel', (data) => {
        if (data.detail && data.detail === 'road_assistance_agreement') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_travel_road_assistance, 'Te rugăm să citești și să accepți termenii și condițiile de prelucrare a datelor cu caracter personal pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-travel-status', {field: 'road_assistance_agreement', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>